import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconNames } from '../../common';
import { DISPLAY_DATE_FORMAT } from '../../common/constants/date-config';
import { LocalDate } from '../../store/models/local-date.model';

@Component({
  selector: 'ui-dates-with-divider',
  templateUrl: './dates-with-divider.component.html',
  styleUrls: ['./dates-with-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatesWithDividerComponent {
  @Input() label: string;
  @Input() startDate: LocalDate;
  @Input() endDate: LocalDate;

  @Input() arrivalDeviation: string;
  @Input() departureDeviation: string;

  @Input() showWarningIcon: boolean;
  @Input() warningMessage: string;

  dateFormat = DISPLAY_DATE_FORMAT;
  iconNameList = IconNames;
}
